import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Subject } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LoginServiceServiceService {

  headerOptions: any = null

  _isLoggedIn: boolean = false

  authSub = new Subject<any>();

  googleAuthURL = environment.googleAuthURL;

  constructor(private _http: HttpClient) {
  }

  loginAuth(userObj: any) {
    if (userObj.authcode) {
      console.log('Appending headers');
      this.headerOptions = new HttpHeaders({
        'x-tfa': userObj.authcode
      });
    }
    return this._http.post( this.googleAuthURL + "/login", { uname: userObj.uname, upass: userObj.upass }, { observe: 'response', headers: this.headerOptions });
  }

  setupAuth() {
    return this._http.post(this.googleAuthURL + "/tfa/setup", {}, { observe: 'response' })
  }

  registerUser(userObj: any) {
    return this._http.post(this.googleAuthURL + "/register", { uname: userObj.uname, upass: userObj.upass }, { observe: "response" });
  }

  updateAuthStatus(value: boolean) {
    this._isLoggedIn = value
    this.authSub.next(this._isLoggedIn);
    localStorage.setItem('isLoggedIn', value ? "true" : "false");
  }

  getAuthStatus() {
    this._isLoggedIn = localStorage.getItem('isLoggedIn') == "true" ? true : false;
    return this._isLoggedIn
  }

  logoutUser() {
    this._isLoggedIn = false;
    this.authSub.next(this._isLoggedIn);
    localStorage.setItem('isLoggedIn', "false")
  }

  getAuth() {
    return this._http.get(this.googleAuthURL + "/tfa/setup", { observe: 'response' });
  }

  deleteAuth() {
    return this._http.delete(this.googleAuthURL + "/tfa/setup", { observe: 'response' });
  }

  verifyAuth(token: any) {
    return this._http.post(this.googleAuthURL + "/tfa/verify", { token }, { observe: 'response' });
  }



  // My Routes
  loginAuth_backvault(userObj: any) {
    if (userObj.authcode) {
      console.log('Appending headers');
      this.headerOptions = new HttpHeaders({
        'x-tfa': userObj.authcode
      });
    }
    return this._http.post(this.googleAuthURL + "/login/backvault", { uname: userObj.uname, upass: userObj.upass, secret: userObj.secret }, { observe: 'response', headers: this.headerOptions });
  }




}
